module.exports = __webpack_public_path__ + "img/assetMaintenanceRecords.da8460d0.svg";